import appEnv from './../../app.env.json';

export const environment = {
  production: true,
  PUBLIC_CONFIG: {
    ...appEnv.prod.PublicConfig,
  },
};
